import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {MyReferralsFlowEndPoints} from 'main/factories/usecases/endpoints';
import {GetReferralDetailsList} from './referral-details';
import {RemoteGetReferralDetails} from './remote-get-referral-details';

export const makeGetReferralDetails = (): GetReferralDetailsList =>
	new RemoteGetReferralDetails(
		makeBFFApiUrl(MyReferralsFlowEndPoints.referralDetails),
		makeAuthorizeHttpClientDecorator(),
	);
